export { UiDoctorMapsBase } from './lib/UiDoctorMapsBase';
export type { UiDoctorMapsBaseProps } from './lib/UiDoctorMapsBase';
